<template>
  <div>
    <v-btn 
      block 
      depressed 
      class="ma-0" 
      @click="searchdialog = true">
      Lisää tuote...
    </v-btn>
    <v-dialog 
      v-model="searchdialog" 
      fullscreen>
      <v-card v-if="searchdialog">
        <v-toolbar flat>
          <!-- <v-slide-x-transition mode="out-in"> -->
          <v-btn 
            v-if="search" 
              
            icon 
            color="success" 
            @click="custom">
            <v-icon>add</v-icon>
          </v-btn>
          <!-- </v-slide-x-transition> -->
          <v-text-field 
            v-if="searchdialog" 
            v-model="search" 
            autofocus 
            hide-details 
            solo 
            placeholder="Lisää tuote..." 
            @keyup.enter.native="custom" />
          <v-btn 
            icon 
            @click="searchdialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
        <v-data-table 
          :headers="[{value: 'name'},{value: 'product_no'}]" 
          :items="list" 
          :search="search" 
          hide-actions 
          hide-headers>
          <template 
            slot="items" 
            slot-scope="props">
            <tr @click="insert(props.item)">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.product_no }}</td>
            </tr>
          </template>
          <template slot="no-data">
            Haulla ei löytynyt tuloksia
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const _ = require('underscore')
export default {
	props: ['index'],
	data() {
		return {
			search: '',
			list: [],
			searchdialog: false
		}
	},
	watch: {
		search() {
			if (this.search !== null && this.search !== '') {
				this.$http
					.get(
						this.$store.state.api_url +
              '/varastootto/act/find_product_data/?q=' +
              this.search,
						{
							before(request) {
								if (this.previousRequest) {
									this.previousRequest.abort()
								}
								this.previousRequest = request
							}
						}
					)
					.then(
						res => {
							this.list = res.body
						},
						error => {}
					)
			}
		}
	},
	methods: {
		insert(item) {
			let itemclone = JSON.parse(JSON.stringify(item))
			this.$store.commit('insertIntoCart', {
				cart: this.index,
				product: itemclone
			})
			this.search = null
			this.searchdialog = false
		},
		custom() {
			var res = _.find(this.list, { product_no: this.search })
			if (res) {
				let itemclone = JSON.parse(JSON.stringify(res))
				this.$store.commit('insertIntoCart', {
					cart: this.index,
					product: itemclone
				})
			} else {
				this.$store.dispatch('custom', {
					index: this.index,
					name: this.search
				})
			}
			this.search = null
			this.searchdialog = false
		}
	}
}
</script>
